import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useRTL } from "hooks/isRTL";
import SearchIcon from "assets/icons/search.svg";
import FiltersIcon from "assets/icons/FiltersIcon.svg";
import { useState } from "react";
import FlashingCards from "./FlashingCardComponents/FlashingCards";
import { IssueTypeEnum } from "enums/shared";

/**
 * Displays a dashboard for flashing cards with search functionality and pagination.
 *
 * The box which act like the parent
 *
 * @component
 * @returns {JSX.Element} The flashing cards dashboard UI.|
 */
function FlashingCardsDashboard({ selectedTypes, setSelectedTypes, orderType }) {
  const { t, isRTL } = useRTL();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchBar, setSearchBar] = useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  // const [selectedTypes, setSelectedTypes] = useState([]);

  const cardsPerPage = 10;

  const handleSearchChange = (e) => {
    setSearchBar(e.target.value);
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };

  const handleCheckboxChange = (type) => {
    setSelectedTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  return (
    <Box
      sx={{
        width: "31%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "9px",
        zIndex: 1,
        backgroundColor: "background.white",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.6)",
        position: "absolute",
        top: "66px",
        ...(isRTL ? { left: 0 } : { right: 0 }),
        height: "100vh", //scrollable
        overflow: "auto",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: "text.red",
          padding: "1rem 1rem 0rem 1rem",
        }}
      >
        {t("needsAttention")}!
      </Typography>

      {/* search */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: "1rem",
          marginBottom: "1rem",
        }}
      >
        <TextField
          placeholder={t("search")}
          variant="standard"
          value={searchBar}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img
                  src={SearchIcon}
                  alt="Search"
                  style={{
                    width: "25px",
                    height: "25px",
                  }}
                />
              </InputAdornment>
            ),
          }}
          sx={{
            flex: 1,
          }}
        />

        <IconButton
          onClick={toggleFilterVisibility}
          aria-label="filter"
          sx={{
            width: "36px",
            height: "36px",
            borderRadius: "8px",
          }}
        >
          <img
            src={FiltersIcon}
            alt="Filters"
            style={{
              width: "25px",
              height: "25px",
            }}
          />
        </IconButton>
      </Box>

      {/* this should be scrollable  */}
      <Box
        sx={{
          flex: "1",
          overflowY: "auto",
        }}
      >
        {/* filter Box */}
        {isFilterVisible && (
          <Box
            sx={{
              margin: "0rem 1rem 1rem;",
              padding: "1rem",
              border: "1px solid #5F6368",
              borderRadius: "8px",
              display: "grid",
              gridTemplateColumns: "repeat(2, auto)",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            }}
          >
            {Object.entries(IssueTypeEnum).map(([key, { value }]) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={selectedTypes.includes(Number(key))}
                    onChange={() => handleCheckboxChange(Number(key))}
                  />
                }
                label={t(value)}
                sx={{
                  "& .MuiTypography-root": {
                    // color: "black",
                    fontWeight: "700",
                  },
                }}
              />
            ))}
          </Box>
        )}

        <FlashingCards
          currentPage={currentPage}
          searchBar={searchBar}
          cardsPerPage={cardsPerPage}
          setCurrentPage={setCurrentPage}
          selectedTypes={selectedTypes}
          orderType={orderType}
        />
      </Box>
    </Box>
  );
}

export default FlashingCardsDashboard;
